import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.widgetbgcolorskyblue};
`;
export const MainLayoutRow = styled.div``;
export const PageContent = styled(Content)`
  height: calc(100vh - 64px);
  background: ${(props) => props.theme.widgetbgcolorskyblue};
  padding: 32px;
  overflow: auto;
  @media (min-width: 0px) and (max-width: 820px) {
    padding: 0;
  }h1 {
    font-size: 36px;
  }
`;
